var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSliderDefault(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 98,
    height: 98,
    rx: 49,
    stroke: "white",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 48.5C29.1716 48.5 28.5 49.1716 28.5 50C28.5 50.8284 29.1716 51.5 30 51.5L30 48.5ZM71.0607 51.0607C71.6464 50.4749 71.6464 49.5251 71.0607 48.9393L61.5147 39.3934C60.9289 38.8076 59.9792 38.8076 59.3934 39.3934C58.8076 39.9792 58.8076 40.9289 59.3934 41.5147L67.8787 50L59.3934 58.4853C58.8076 59.0711 58.8076 60.0208 59.3934 60.6066C59.9792 61.1924 60.9289 61.1924 61.5147 60.6066L71.0607 51.0607ZM30 51.5L70 51.5L70 48.5L30 48.5L30 51.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSliderDefault);
export default __webpack_public_path__ + "static/media/SliderDefault.e68309f8b48a3e63f8324475ea4914a3.svg";
export { ForwardRef as ReactComponent };